import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './Tooltip.scss';

const TooltipInner = ({
  child,
  className,
  showArrow,
  placement,
  arrowStyles,
  tooltipStyles,
  forwardedRef,
  ...props
}) => {
  return ReactDOM.createPortal(
    <div
      className={`${className || ''} tooltip in fade ${placement || ''}`}
      style={tooltipStyles}
      {...props}
      ref={forwardedRef}
    >
      {showArrow && (
        <div className="tooltip-arrow" style={!arrowStyles ? { left: '50%' } : arrowStyles}></div>
      )}
      <div className="tooltip-inner">{child}</div>
    </div>,
    document.body
  );
};
export default function Tooltip({ className, showArrow = true, reference, placement, ...props }) {
  const mainRef = useRef();
  const tooltipRef = useRef();
  const [arrowStyles, setArrowStyles] = useState();
  const [tooltipStyles, setTooltipStyles] = useState();
  useEffect(() => {
    const ele = mainRef.current;
    if (placement && reference && tooltipRef.current) {
      const { left, top, height, width } = reference.getBoundingClientRect();
      let modLeft = left;
      let modTop = top;
      const { height: tooltipHeight, width: tooltipWidth } =
        tooltipRef.current.getBoundingClientRect();
      let arrowLeft = left;
      let arrowTop = top;
      const arrowHeight = 5;
      switch (placement) {
        case 'top':
          modTop -= tooltipHeight;
          modLeft = left - (tooltipWidth - width) / 2;
          arrowTop = 'calc(100% - 5px)';
          arrowLeft = '50%';
          break;
        case 'left':
          modLeft -= tooltipWidth + arrowHeight;
          modTop = top - (tooltipHeight - height) / 2;
          arrowTop = '50%';
          arrowLeft = 'calc(100% - 5px)';
          break;
        case 'right':
          modLeft += width + arrowHeight;
          modTop = top - (tooltipHeight - height) / 2;
          arrowTop = '50%';
          arrowLeft = '0';
          break;
        case 'bottom':
          modTop += height + arrowHeight;
          modLeft = left - (tooltipWidth - width) / 2;
          arrowTop = '0';
          arrowLeft = '50%';
          break;
        default:
          break;
      }
      setArrowStyles({ left: arrowLeft, top: arrowTop, position: 'absolute' });
      setTooltipStyles({ left: modLeft, top: modTop });
    } else if (ele) {
      const { left, top } = ele.getBoundingClientRect();
      setTooltipStyles({ left, top });
    }
    return () => {};
  }, [mainRef.current, reference, placement, tooltipRef.current]);

  return (
    <>
      <div ref={mainRef}></div>
      <TooltipInner
        {...props}
        arrowStyles={arrowStyles}
        child={props.children}
        className={className}
        forwardedRef={tooltipRef}
        placement={placement}
        showArrow={showArrow}
        tooltipStyles={tooltipStyles}
      />
    </>
  );
}
